// ResultPoint 顯示用的莊家付款關係補充；純資料轉換，不直接渲染。
//
// === 使用圖片 ===
// 無 — 純函式。

import { dealerRelationTaiFor, type TSeat } from '@core/index';
import { RoundSummaryKind, type TRoundSummary } from '@core/summary';

/**
 * 閒家胡到莊家打出的牌時，核心牌型計分不會把付款者關係算進 winner 台型；
 * ResultPoint 仍須顯示「莊家」或「連 N 拉 N」，並與實際付款金額一致。
 */
export const addDealerRelationToResultSummary = (
  summary: TRoundSummary,
  dealerSeat: TSeat,
  dealerStreak: number
): TRoundSummary => {
  if (summary.kind !== RoundSummaryKind.Hu) return summary;
  const result = summary.results[0];
  if (!result || result.seat === dealerSeat || result.loserSeat !== dealerSeat) return summary;

  const points = dealerRelationTaiFor(dealerStreak);
  return {
    kind: RoundSummaryKind.Hu,
    results: [
      {
        ...result,
        scoreItems: [
          ...result.scoreItems,
          {
            key: dealerStreak > 0 ? 'lianzhuang' : 'dealer',
            points,
          },
        ],
        total: result.total + points,
      },
    ],
  };
};
